const BASE = 'https://images.footy-games.com.ar';
const FOLDER_PATH = 'sofascore/sofascore_images';

export const getImgSrc = (img) => {
    if (!img) return img;

    // 1) Si es SofaScore, extraigo el ID y apunto a R2
    const sofascoreMatch = img.match(/player\/(\d+)\/image/);
    if (sofascoreMatch) {
        const id = sofascoreMatch[1];
        return `${BASE}/${FOLDER_PATH}/${id}.webp`;
    }

    // 2) Si es URL de Cloudinary, la convierto a R2
    const cloudinaryMatch = img.match(/res\.cloudinary\.com\/drukypnqv\/image\/upload\/(?:v\d+\/)?(.+?)(?:\.(?:jpg|png|webp))?$/);
    if (cloudinaryMatch) {
        return `${BASE}/${cloudinaryMatch[1]}.webp`;
    }

    // 3) Si no, uso directamente la URL que venga
    return img;
};
